"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeSxProps = void 0;
function mergeSxProps(sxProps1, sxProps2) {
    const sxList1 = Array.isArray(sxProps1) ? sxProps1 : [sxProps1];
    const sxList2 = Array.isArray(sxProps2) ? sxProps2 : [sxProps2];
    return [...sxList1, ...sxList2].filter(Boolean);
}
exports.mergeSxProps = mergeSxProps;
//# sourceMappingURL=mergeSxProps.js.map